import template from "./verpackung-gruppe-verpackung.html.twig";
import {getUid} from "../../../../utils/utils";

Packlab.Component.register('verpackung-gruppe-verpackung', {
    template,

    props: {
        verpackung: {
            type: Object,
            required: true
        },
        ruleset: {
            type: Object,
            required: true
        },
        isChild: {
            type: Boolean,
            required: false,
            default: false
        },
        showEanField: {
            type: Boolean,
            required: false,
            default: true
        },
        isReadonly: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            uid: getUid()
        }
    },

    methods: {
        getAccordionTitleSlot(key) {
            return `item-${key}-title`;
        },
        getAccordionContentSlot(key) {
            return `item-${key}-content`;
        }
    }
});
